import { render, staticRenderFns } from "./sensitiveWordsList.vue?vue&type=template&id=dd29603e"
import script from "./sensitiveWordsList.vue?vue&type=script&lang=js"
export * from "./sensitiveWordsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports